import { render, staticRenderFns } from "./a-static.vue?vue&type=template&id=6a5d4376&scoped=true&"
import script from "./a-static.vue?vue&type=script&lang=js&"
export * from "./a-static.vue?vue&type=script&lang=js&"
import style0 from "./a-static.vue?vue&type=style&index=0&id=6a5d4376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d4376",
  null
  
)

export default component.exports